import { render, staticRenderFns } from "./EditStudentInfo.vue?vue&type=template&id=51f0f0fa&scoped=true&"
import script from "./EditStudentInfo.vue?vue&type=script&lang=js&"
export * from "./EditStudentInfo.vue?vue&type=script&lang=js&"
import style0 from "./EditStudentInfo.vue?vue&type=style&index=0&id=51f0f0fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f0f0fa",
  null
  
)

export default component.exports